module.exports = __webpack_public_path__ + "img/short-hand-logo.5d962d4e.png";